import { getAuth } from "firebase/auth";
import {
  getFirestore,
  where,
  startAfter,
  getDocs,
  query,
  collection,
  limit,
  orderBy,
  doc,
  getDoc,
} from "firebase/firestore";

const firestore = getFirestore();
const auth = getAuth();

let REACT_APP_SEARCH_BACKEND_URL =
  process.env.REACT_APP_SEARCH_BACKEND_URL ?? "https://bright-fox-galoshes.cyclic.cloud";

export async function filterBySemBranch(filter, count, lastDoc) {
  const filterQueries = [];
  Object.keys(filter).forEach((key) => {
    if (filter[key]) filterQueries.push(where(key, "==", filter[key]));
  });
  if (count !== null) filterQueries.push(limit(count));
  filterQueries.push(orderBy("name", "asc"));
  if (lastDoc !== null) filterQueries.push(startAfter(lastDoc));

  const studentsPartialRef = collection(firestore, "students_partial");
  const finalQuery = query(studentsPartialRef, ...filterQueries);
  const resultDocs = await getDocs(finalQuery);

  if (resultDocs.empty) return { result: [], lastDocSnapshot: null };
  let lastDocSnapshot = null,
    i = 0;
  const result = [];
  resultDocs.forEach((resultDoc) => {
    if (resultDoc.exists()) result.push(resultDoc.data());
    if (i === resultDocs.size - 1) {
      if (count !== null && resultDocs.size === count) lastDocSnapshot = resultDoc;
      //indicates no more documents to be fetched for that query
    }
    i++;
  });
  return { result, lastDocSnapshot };
}

export async function searchStudent(query) {
  const token = await auth.currentUser.getIdToken();
  const url = new URL(`${REACT_APP_SEARCH_BACKEND_URL}/students/search?query=${query}`);
  const response = await fetch(url, {
    headers: {
      Accept: "application/json",
      authorization: `Bearer ${token}`,
    },
  });
  const data = await response.json();
  const result = data.output || [];
  return result;
}

export async function getStudentNames() {
  const token = await auth.currentUser.getIdToken();
  const url = new URL(`${REACT_APP_SEARCH_BACKEND_URL}/students/list`);
  const response = await fetch(url, {
    headers: {
      Accept: "application/json",
      authorization: `Bearer ${token}`,
    },
  });
  const data = await response.json();
  const result = data.output || [];
  return result;
}
